export default "__VITE_ASSET__BJJ170zG__"